import { useState } from "react";
import { ptBR } from "date-fns/locale";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { CalendarDays, X } from "lucide-react";

export const isoDate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function DataPt({ value, onChange, testid, placeholder = "Escolher data", limpar = false }) {
  const [open, setOpen] = useState(false);
  const hoje = isoDate(new Date());
  return (
    <div className="flex gap-1">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" className="w-full justify-start font-normal" data-testid={testid}>
            <CalendarDays className="w-4 h-4 mr-1" />{value ? value.split("-").reverse().join("/") : placeholder}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar mode="single" locale={ptBR} selected={value ? new Date(`${value}T12:00:00`) : undefined}
            disabled={(d) => isoDate(d) < hoje} onSelect={(d) => { if (d) { onChange(isoDate(d)); setOpen(false); } }} data-testid={`${testid}-calendario`} />
        </PopoverContent>
      </Popover>
      {limpar && value && <Button variant="ghost" size="icon" onClick={() => onChange("")} data-testid={`${testid}-limpar`}><X className="w-4 h-4" /></Button>}
    </div>
  );
}
